export default {
      id: "social-05-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#social-05",
      toString: function () {
        return this.url;
      }
    }